import { render, staticRenderFns } from "./WorkProcedureChild.vue?vue&type=template&id=9c24cd74&scoped=true&"
import script from "./WorkProcedureChild.vue?vue&type=script&lang=js&"
export * from "./WorkProcedureChild.vue?vue&type=script&lang=js&"
import style0 from "./WorkProcedureChild.vue?vue&type=style&index=0&id=9c24cd74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c24cd74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c24cd74')) {
      api.createRecord('9c24cd74', component.options)
    } else {
      api.reload('9c24cd74', component.options)
    }
    module.hot.accept("./WorkProcedureChild.vue?vue&type=template&id=9c24cd74&scoped=true&", function () {
      api.rerender('9c24cd74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/common/components/WorkProcedureChild.vue"
export default component.exports